import { NgModule } from '@angular/core';
import { Page451ComponentsModule } from '@element451-libs/page451-lib';
import { VideoPreviewService } from '@element451-libs/utils451/video';
import { EffectsModule } from '@ngrx/effects';
import { MediaEffects, MediaService } from './media';

@NgModule({
  imports: [EffectsModule.forFeature([MediaEffects]), Page451ComponentsModule],
  providers: [MediaService, VideoPreviewService]
})
export class HomeStoreModule {}
